<template>
  <el-dialog
    :visible.sync="innerVisible"
    width="70%"
    custom-class="joint-cooperation-config-dialog"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <div slot="title" class="dialog-title-block">
      <div class="dlg-title">联营配置</div>
      <div class="dlg-actions">
        <el-button type="primary" size="small" :loading="submitting" @click.stop="onSubmit">
          保存
        </el-button>
      </div>
    </div>

    <div class="dialog-body-inner" v-loading="loading">
      <el-row :gutter="16" type="flex" class="card-list">
        <el-col
          v-for="item in table.list"
          :key="item.id"
          :span="6"
          class="card-list-item"
        >
          <el-card
            shadow="hover"
            class="tpl-card"
            :class="{ 'is-active': selectedTplId === item.id }"
            @click.native="onChooseCard(item)"
          >
            <div class="card-head">
              <span class="card-title">收益共享</span>
              <el-tag
                v-if="item.isDefault"
                size="small"
                type="info"
                class="default-tag"
              >
                默认
              </el-tag>
            </div>
            <div class="card-body">
              <div
                v-for="(rule, idx) in item.shareList || []"
                :key="`${item.id}-${rule.sortNo ?? idx}`"
                class="rule-row"
              >
                <span>出资比例 {{ rule.capitalRatio }}%</span>
                <span>收益率 {{ rule.incomeRate }}%</span>
              </div>
            </div>
            <div class="card-footer">
              <span class="template-name">{{ item.tplName || "-" }}</span>
              <el-link
                :underline="false"
                type="primary"
                @click.stop="openDetail(item)"
              >
                查看详情
              </el-link>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="table.currentPage"
        :page-size="table.pageSize"
        :total="table.total"
      />
    </div>

    <DetailDialog
      :visible.sync="detailVisible"
      :detail-data="detailData"
    />
  </el-dialog>
</template>

<script>
import DetailDialog from "@/views/store-cooperation/config/components/detail-dialog.vue";
import {
  getJointCooperationTplListAPI,
  saveJointPartnerCooperationTplAPI,
} from "../api";

export default {
  name: "JointCooperationConfigDialog",
  components: {
    DetailDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, String],
      default: null,
    },
    /** 门店当前已选的联营配置模板 id */
    currentTplId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      innerVisible: false,
      loading: false,
      submitting: false,
      selectedTplId: null,
      table: {
        currentPage: 1,
        pageSize: 8,
        total: 0,
        list: [],
      },
      detailVisible: false,
      detailData: {
        tplName: "",
        shareList: [],
      },
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.innerVisible = val;        
        if (val && this.id) {
          this.selectedTplId =
            this.currentTplId != null && this.currentTplId !== ""
              ? Number(this.currentTplId)
              : null;
          this.table.currentPage = 1;
          this.loadTemplates();
        }
      },
    },
    "table.currentPage"() {
      if (!this.innerVisible) {
        return;
      }
      this.loadTemplates();
    },
    innerVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  methods: {
    async loadTemplates() {
      this.loading = true;
      try {
        const res = await getJointCooperationTplListAPI({
          page: this.table.currentPage,
          pageSize: this.table.pageSize,
        });
        const rawList = res.list || [];
        this.table.list = rawList;
        this.table.total = res.total || 0;
      } catch {
        this.table.list = [];
        this.table.total = 0;
      } finally {
        this.loading = false;
      }
    },
    onChooseCard(item) {
      this.selectedTplId = item.id;
    },
    openDetail(item) {
      this.detailData = {
        tplName: item.tplName || "",
        shareList: item.shareList || [],
      };
      this.detailVisible = true;
    },
    async onSubmit() {
      if (!this.selectedTplId) {
        this.$message.warning("请选择联营配置模板");
        return;
      }
      this.submitting = true;
      try {
        await saveJointPartnerCooperationTplAPI({
          id: this.id,
          jointTplId: this.selectedTplId,
          // 模板类型：1-收益共享
          jointTplType: 1,
        });
        this.$message.success("保存成功");
        this.$emit("saved");
        this.onClose();
      } finally {
        this.submitting = false;
      }
    },
    onClose() {
      this.table.list = [];
      this.table.total = 0;
      this.table.currentPage = 1;
      this.selectedTplId = null;
      this.detailVisible = false;
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-title-block {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  width: 100%;
  padding-right: 40px;
  box-sizing: border-box;
}

.dlg-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  line-height: 1.4;
}

.dlg-actions {
  display: flex;
  justify-content: flex-end;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  flex-shrink: 0;
}

.dialog-body-inner {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.card-list {
  flex-wrap: wrap;
  align-items: stretch;
}

.card-list-item {
  margin-bottom: 16px;
  display: flex;
}

.tpl-card {
  cursor: pointer;
  width: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  border: 2px solid #ebeef5;
  box-sizing: border-box;

  &.is-active {
    border-color: #409eff;
    box-shadow: 0 0 0 1px rgba(64, 158, 255, 0.2);
  }

  ::v-deep .el-card__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    padding: 12px;
    box-sizing: border-box;
  }

  .card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    min-height: 24px;
    flex-shrink: 0;

    .card-title {
      font-size: 14px;
      font-weight: 600;
      color: #67c23a;
    }

    .default-tag {
      border-radius: 2px;
    }
  }

  .card-body {
    flex: 1;
    min-height: 140px;
    border: 1px solid #ebeef5;
    padding: 8px 10px;
    overflow-y: auto;
    margin-bottom: 8px;

    .rule-row {
      display: flex;
      justify-content: space-between;
      line-height: 28px;
      color: #606266;
      font-size: 14px;
      border-bottom: 1px dashed #ebeef5;

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    flex-shrink: 0;
    margin-top: auto;

    .template-name {
      font-weight: 500;
      color: #303133;
      font-size: 14px;
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>

<style lang="scss">
.joint-cooperation-config-dialog.el-dialog {
  margin-top: 6vh !important;
  height: 78vh;
  max-height: 900px;
  display: flex;
  flex-direction: column;
}

.joint-cooperation-config-dialog {
  .el-dialog__header {
    padding: 16px 20px 8px;
    flex-shrink: 0;
  }
  .el-dialog__body {
    padding-top: 8px;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}
</style>
